import React, { useCallback } from 'react';
import { RealtyObjectType } from '@search/filter-enums/enums';
import { CategoryTypeFilter } from '../../../../../filters/models/Filter';
import { SlimSelect } from '../../../../../common/components/SlimSelect/SlimSelect';

interface IProps {
    filter: CategoryTypeFilter;
    enabledSegments: RealtyObjectType[];
    onChange: (filter: CategoryTypeFilter) => void;
}

function getOptions(enabledSegments: RealtyObjectType[]) {
    return SELECT_OPTIONS.map(item => {
        if (! enabledSegments.includes(Number(item.value))) {
            item.disabled = true;
        } else {
            item.disabled = false;
        }

        return item;
    });
}

const SELECT_OPTIONS = [
    {
        label: 'Квартиру',
        value: RealtyObjectType.FLAT.toString()
    },
    {
        label: 'Комнату',
        value: RealtyObjectType.ROOM.toString(),
        disabled: true
    },
    {
        label: 'Участок',
        value: RealtyObjectType.LAND.toString(),
        disabled: true
    },
    {
        label: 'Дом',
        value: RealtyObjectType.HOUSE.toString(),
        disabled: true
    }
];

export const DesktopRealtyTypeFilterView: React.FC<IProps> = ({
    filter,
    enabledSegments,
    onChange,
}) => {
    const options = getOptions(enabledSegments);

    const handleChange = useCallback(
        (val: string) => {
            const parsedValue = parseInt(val, 10) as RealtyObjectType;

            onChange(new CategoryTypeFilter(parsedValue));
        },
        [ onChange ]
    );

    return (
        <SlimSelect
            dataTest='categoryType'
            size='s'
            placeholder='Тип недвижимости'
            options={options}
            value={filter.categoryType.toString()}
            onChange={handleChange}
            adaptiveHeight={false}
            adaptivePlacement={false}
        />
    );
};
